import { EventContentArg } from '@fullcalendar/core';
import { Stack, Box } from '@mui/material';

export default function EventTile(eventInfo: EventContentArg) {
  return (
    <Stack
      sx={{
        color: '#333',
        fontSize: '0.85rem',
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
      }}
      direction='row'
      justifyContent='space-between'
      alignItems='center'
    >
      <Box>{eventInfo?.event?.title}</Box>
      {eventInfo?.timeText && <Box>{eventInfo?.timeText}</Box>}
    </Stack>
  );
}
